module.exports = __webpack_public_path__ + "img/zsfwct4.d2c27f7b.png";